const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const ShoppingCartUtils = require('./utils/shopping.cart.utils');
const AvailabilityUtils = require('./utils/availability.utils');

const insuranceCollection = require('od-modules/collections/insurance_catalogue.collection').getInstance();
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();

const getPromise = () => Promise.all([insuranceCollection.getLoadedPromise(), websiteConfigCollection.getLoadedPromise()]);

const start = () => AvailabilityUtils.isEnabled() ? ShoppingCartUtils.addProduct() : false;

module.exports = createWidgetFactory({
    name: 'free_cancellation',
    modelClass: Backbone.Model.extend({
        initialize() {
            getPromise().then(start);
        },
    }),
});
